'use strict';

import React from 'react';
import classnames from 'classnames';
import otIconLab from '../../../images/icons/labra-white.svg';
import otIconImaging from '../../../images/icons/kuvantaminen-white.svg';
import otIconHearingAid from '../../../images/icons/kuulolaitehuolto-white.svg';
import otPhoneIcon from '../../../images/icons/puhelin-white.svg';
import otReferralIcon from '../../../images/icons/src/lahete.svg';
import otHospitalWardIcon from '../../../images/icons/src/hoitojakso_osastolla.svg';
import otSleepClinicIcon from '../../../images/icons/src/unipoli-tarvikejakelu.svg';

const customIcons = {
  lab: {
    icon: otIconLab,
    wrapperStyle: 'custom-wrapper-lab',
  },
  imaging: {
    icon: otIconImaging,
    wrapperStyle: 'custom-wrapper-imaging',
  },
  'assistive-listening-systems': {
    icon: otIconHearingAid,
    wrapperStyle: 'custom-wrapper-assistive-listening-systems',
  },
  phone: {
    icon: otPhoneIcon,
    wrapperStyle: 'custom-wrapper-phone',
  },
  referral: {
    icon: otReferralIcon,
    wrapperStyle: 'custom-wrapper-referral',
  },
  hospitalWard: {
    icon: otHospitalWardIcon,
    wrapperStyle: {
      padding: '13px 11px',
    },
    mobileWrapperStyle: {
      padding: '10px 8px',
    },
    imgStyle: {
      width: '28px',
    },
  },
  sleepClinic: {
    icon: otSleepClinicIcon,
    wrapperStyle: {
      padding: '13px 11px',
    },
    mobileWrapperStyle: {
      padding: '10px 8px',
    },
    imgStyle: {
      width: '28px',
    },
  },
};

const TimelineIcon = ({ config, color, past }) => {
  let { type, name } = config;

  let classes = {};
  if (!past) {
    classes[color] = true;
  } else {
    classes.past = true;
  }
  if (config.type === 'custom') {
    return (
      <div className={classnames('ot-icon-container', classes)}>
        <div className={classnames("ot-icon-wrapper", `custom-wrapper-${name}`)}>
          <img
              alt={`Ikoni: ${name}`}
              src={customIcons[name].icon}
          />
        </div>
      </div>
    );
  } else if (type === 'fa') {
    return (
      <div className={classnames('ot-icon-container', classes)}>
        <div className="ot-icon-wrapper">
          <i className={classnames(name)} />
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default TimelineIcon;
